import { Controller } from "@hotwired/stimulus"

// Fills the Shopify connection list from the chosen account.
//
// Both selects have to sit inside the controller's element: a Stimulus target
// is looked up within scope, so mounting this on the account select — with
// its target on the sibling connection select — raised on every change and
// left the list reading "Select account first..." forever.
export default class extends Controller {
  static targets = ["account", "select"]

  connect() {
    // A value can already be there on load: a restored form, autofill, or a
    // back button. Nothing would have fired a change event for it.
    if (this.hasAccountTarget && this.accountTarget.value) this.fill(this.accountTarget.value)
  }

  load(event) {
    this.fill(event.target.value)
  }

  async fill(accountId) {
    const select = this.selectTarget

    if (!accountId) {
      this.replace(select, '<option value="">Select account first...</option>')
      return
    }

    this.replace(select, '<option value="">Loading...</option>')

    try {
      const response = await fetch(`/admin/connections?account_id=${accountId}`, {
        headers: { "Accept": "application/json" }
      })
      if (!response.ok) throw new Error(`${response.status}`)

      const connections = await response.json()
      if (connections.length === 0) {
        this.replace(select, '<option value="">No connections found</option>')
        return
      }

      // Labels come from Shopify shop names: build the options as nodes
      // rather than markup so a name can never inject into the page.
      select.replaceChildren(...connections.map(c => this.option(c.id, c.label)))
    } catch (error) {
      // Say so in the control itself. A silent failure here looks exactly
      // like an account with no connections, which is what sent someone
      // looking in the database.
      select.replaceChildren(this.option("", `Could not load connections (${error.message})`))
    }
  }

  replace(select, html) {
    select.innerHTML = html
  }

  option(value, label) {
    const option = document.createElement("option")
    option.value = value
    option.textContent = label
    return option
  }
}
